<div class="p-fluid">

    <div class="p-grid" *ngIf="entidade.id != null">
      <div class="p-col-12 p-lg-2">
        <label for="id">Id:</label>
      </div>
      <div class="p-col-12 p-lg-10">
        <input pInputText type="text" name="id" disabled [ngModel]="entidade.id" />
      </div>
    </div>

    <div class="p-grid">
      <div class="p-col-12 p-lg-2">
        <label for="origem">Origem:</label>
      </div>
      <div class="p-col-12 p-lg-10">
        <input pInputText type="text" name="origem" disabled [ngModel]="entidade.fonteDados?.nome" />
      </div>
    </div>

    <div class="p-grid">
      <div class="p-col-12 p-lg-2">
        <label for="origemId">Id Origem:</label>
      </div>
      <div class="p-col-12 p-lg-10">
        <input pInputText type="text" name="origemId" disabled [ngModel]="entidade.origemId" />
      </div>
    </div>

    <div class="p-grid">
        <div class="p-col-12 p-lg-2">
            <label for="nome">Nome:</label>
        </div>
        <div class="p-col-12 p-lg-10">
            <input pInputText type="text" name="nome" disabled [ngModel]="entidade.nome" />
        </div>
    </div>

    <div class="p-grid">
        <div class="p-col-12 p-lg-2">
            <label for="nome">Órgão Julgador:</label>
        </div>
        <div class="p-col-12 p-lg-10">
            <p-autoComplete
            [(ngModel)]="entidade.tipoProcessoDocumento"
            [suggestions]="tipoProcessoDocumentoSugestoes"
            (completeMethod)="onCompleteTipoProcessoDocumento($event.query)"
            field="nome"
            appendTo="body"
            forceSelection="true"
            required="true"
            placeholder="Pesquise por um órgão julgador (no mínimo 3 caracteres)"
            showEmptyMessage="true"
            minLength=3
            virtualScroll="true"
            emptyMessage="Não foi encontrado nenhum órgão julgador"
            delay=700>

            <ng-template let-orgaoJulgador pTemplate="item">
                  <span style="min-width: 10vw;">{{orgaoJulgador.id}}</span>
                  <span style="min-width: 15vw; margin-left: 20px;">{{orgaoJulgador.orgaoJustica?.sigla}}</span>
                  <div style="float: right;">{{orgaoJulgador.nome}}</div>
            </ng-template>

            </p-autoComplete>
        </div>
    </div>


</div>
